export const BRAND = {
  name: "Yeliz Kıran Pastırmacıoğlu",
  shortName: "Yeliz Kıran",
  initials: "YKP",
  tagline: "Spiritüel Rehber & Enerji Çalışmacısı",
  whatsappPhone: "905555555555",
  displayPhone: "+90 555 555 55 55",
  email: "info@yelizkiranpastirmacioglu.com",
  city: "İstanbul · Online & Bireysel",
  instagram: "@yelizkiranpastirmacioglu",
};

export const SERVICES = [
  {
    slug: "frekanslarla-sifa",
    title: "Frekanslarla Şifa",
    short: "Ses frekansları ve titreşimle hücresel hizalanma.",
    description:
      "Solfeggio frekansları ve şifa titreşimleriyle bedensel ve enerjisel blokların çözüldüğü, derin dinginlik sağlayan bir seans.",
    suitableFor: [
      "Kronik gerginlik ve uyku problemi yaşayanlar",
      "Zihinsel sis ve odak kaybı hissedenler",
      "Bedensel-duygusal uyumunu bulmak isteyenler",
    ],
    duration: "60 dk",
    format: "Online & Bireysel",
  },
  {
    slug: "soy-karmasi",
    title: "Soy Karması",
    short: "Atalardan miras kalan örüntülerin onarımı.",
    description:
      "Aile sisteminde nesilden nesile aktarılan duygusal yüklerin tanınması ve enerjisel düzeyde çözülmesi için derin bir çalışma.",
    suitableFor: [
      "Tekrar eden ilişki kalıpları yaşayanlar",
      "Bolluk ve para akışında tıkanma hissedenler",
      "Kendine ait olmayan korkular taşıdığını sezenler",
    ],
    duration: "90 dk",
    format: "Bireysel · Online uygundur",
  },
  {
    slug: "numeroloji",
    title: "Numeroloji",
    short: "Doğum sayılarının ışığında ruh haritan.",
    description:
      "İsim ve doğum tarihinden hareketle ruhsal görevin, yetenek alanların ve hayat döngülerinin sayısal okumasını içerir.",
    suitableFor: [
      "Hayat yönünü sorgulayanlar",
      "Kariyer ve ilişki seçimi öncesi rehberlik isteyenler",
      "Kendini daha derin anlamak isteyenler",
    ],
    duration: "75 dk",
    format: "Online · Kayıt teslim edilir",
  },
  {
    slug: "akis-terapisi",
    title: "Akış Terapisi",
    short: "Direnci bırakıp ritmine geri dönüş.",
    description:
      "Nefes, bilinçaltı çalışmaları ve sezgisel sorularla hayatın akışına yeniden hizalanmayı destekleyen bütüncül seans.",
    suitableFor: [
      "Tükenmişlik ve karar yorgunluğu hissedenler",
      "Geçiş dönemlerinde olan kişiler",
      "Kendi sesini yeniden duymak isteyenler",
    ],
    duration: "70 dk",
    format: "Online & Bireysel",
  },
  {
    slug: "ruya-analizi",
    title: "Rüya Analizi",
    short: "Bilinçaltının sembolik dilini çözmek.",
    description:
      "Tekrarlayan rüyalar, semboller ve duygusal izlerin bilinçaltı haritasında ne anlama geldiğinin sezgisel okuması.",
    suitableFor: [
      "Tekrar eden veya yoğun rüyalar görenler",
      "Sezgisel mesajlara açılmak isteyenler",
      "İç dünyasını daha net anlamak isteyenler",
    ],
    duration: "60 dk",
    format: "Online · Yazılı özet eşliğinde",
  },
  {
    slug: "enerji-sifasi",
    title: "Enerji Şifası",
    short: "Aurik temizlik ve çakra hizalama.",
    description:
      "Enerji bedeninin temizlenmesi, çakraların dengelenmesi ve koruma alanının güçlendirilmesi üzerine derin bir şifa seansı.",
    suitableFor: [
      "Yoğun duygu birikimi yaşayanlar",
      "Çevreden ağır etkilenen hassas yapılar",
      "Yeni bir döngüye temizlenerek girmek isteyenler",
    ],
    duration: "75 dk",
    format: "Online & Bireysel",
  },
];

export const SESSION_TYPES = [
  { value: "bireysel", label: "Bireysel Seans" },
  { value: "online", label: "Online Danışmanlık" },
  { value: "grup", label: "Grup Çalışması" },
  { value: "egitim", label: "Eğitim Programı" },
];

export const IMAGES = {
  heroAura:
    "https://static.prod-images.emergentagent.com/jobs/65a1848f-ba37-4815-a53c-012fb7b6f687/images/04cdb262a3dcf54a96bc4336241a1b689cade6122f17bc25bba5c1f84b64514b.png",
  about:
    "https://images.pexels.com/photos/4534606/pexels-photo-4534606.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
  cards:
    "https://static.prod-images.emergentagent.com/jobs/65a1848f-ba37-4815-a53c-012fb7b6f687/images/ebd8d6d0cf9a66aeb31aad6520c9c155c1b4f2e4d1408232ed99d006e79d8072.png",
  crystal:
    "https://static.prod-images.emergentagent.com/jobs/65a1848f-ba37-4815-a53c-012fb7b6f687/images/44b685e48a5e4443034d059a2a12baa6bd92099c4008b201e7844f405b56a166.png",
  water:
    "https://images.pexels.com/photos/18517685/pexels-photo-18517685.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
  hands:
    "https://images.pexels.com/photos/3771115/pexels-photo-3771115.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
  candle:
    "https://images.pexels.com/photos/4498140/pexels-photo-4498140.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
  smoke:
    "https://images.pexels.com/photos/6620838/pexels-photo-6620838.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
};
